import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Button, Alert } from 'react-bootstrap';

import * as Yup from 'yup';
import { Formik } from 'formik';
import useAuth from '../../../hooks/useAuth';
import useScriptRef from '../../../hooks/useScriptRef';
import { customLogin } from './CustomLogin';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Apiloader from '../../../assets/images/loader/Apiloader';
import { ConfigContext } from '../../../contexts/ConfigContext';

const FirebaseLogin = ({ className, ...rest }) => {
  const [apiloader, setApiloader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const scriptedRef = useScriptRef();
  const navigate = useNavigate();

  const {dispatch} = useContext(ConfigContext)

  const { firebaseEmailPasswordSignIn, firebaseGoogleSignIn } = useAuth();

  const googleHandler = async () => {
    try {
      await firebaseGoogleSignIn();
    } catch (err) {
      console.error(err);
    }
  };
  const getData = async (tok, id) => {
    //console.log('fdzxcxcx');
    const h = {
      Authorization: `Bearer ${tok}`,
      'Content-Type': 'application/json'
    };
    try {
      const { data } = await axios.get(`${window.BASE}${window.MY_PROFILE}${id}`, { headers: h });
      //console.log(data)
      localStorage.setItem('memberData', JSON.stringify(data));
    } catch (error) {}
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);

      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);
  return (
    <React.Fragment>
        <Apiloader loader={loader}></Apiloader>
      <Formik
        initialValues={{
          name: '',
          password: '',
          submit: null
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required('User Name is required'),
          password: Yup.string().max(255).required('Password is required')
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            setApiloader(true);
            setLoader(true)
            let t = customLogin(values);
            t.then((data) => {
              setApiloader(false);
              setLoader(false)
              //console.log(data.errorMsgs);
              if (data.result === 'Success') {
                localStorage.setItem('key', 'true');
                if (data.userType === 'Member') {
                  getData(data.token, data.userId);
                  if(width >768){
                    navigate('/member-dashboard');
                  }
                  else{
                    navigate('/pre-dash');
                  }
                  // navigate('/member-dashboard');
                } else {
                  navigate('/admin-dashboard');
                }

                window.location.reload();
              } else {
                setErrors({ submit: data.errorMsgs });
              }
            }).catch((error) => {
              setApiloader(false);
              setLoader(false)
              //console.log(error);
            });

            if (scriptedRef.current) {
              setStatus({ success: true });
              setSubmitting(true);
            }
          } catch (err) {
            console.error(err);
            if (scriptedRef.current) {
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
          <form noValidate onSubmit={handleSubmit} className={className} {...rest}>
            <div className="form-group mb-3">
              <input
                className="form-control"
                error={touched.name && errors.name}
                label="Email Address / Username"
                name="name"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.name}
                placeholder="Member Code"
              />
              {touched.name && errors.name && <small class="text-danger form-text">{errors.name}</small>}
            </div>
            {/* <div className="form-group mb-4">
              <input
                className="form-control"
                error={touched.password && errors.password}
                label="Password"
                name="password"
                onBlur={handleBlur}
                onChange={handleChange}
                type="password"
                value={values.password}
                placeholder='Password'
              />
              {touched.password && errors.password && <small class="text-danger form-text">{errors.password}</small>}
            </div> */}
            <div className="form-group mb-4">
              <div className="input-group ">
                <input
                  className="form-control position-form"
                  error={touched.password && errors.password}
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type={showPassword ? 'text' : 'password'}
                  value={values.password}
                  placeholder="Password"
                />
                <div className=" input-group-icons">
                  <span className="input-group-txt" onClick={togglePasswordVisibility}>
                    <FontAwesomeIcon style={{ color: 'gray' }} icon={showPassword ? faEyeSlash : faEye} />
                  </span>
                </div>
              </div>
              {touched.password && errors.password && <small className="text-danger form-text">{errors.password}</small>}
            </div>

            {errors.submit && (
              <Col sm={12}>
                <Alert variant="danger">{errors.submit}</Alert>
              </Col>
            )}

            <Row>
              <Col mt={2} style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  className="btn-block button-color"
                  id="login-button"
                  disabled={isSubmitting}
                  size="large"
                  type="submit"
                  variant="primary"
                >
                  {apiloader ? <span id=""></span> : <span>Signin</span>}
                </Button>
              </Col>
            </Row>
          </form>
        )}
      </Formik>
  
    </React.Fragment>
  );
};

export default FirebaseLogin;
